import {useEffect, useState} from "react";
import {showHideBodyContainer} from "../../util/util";
import SendEmailForm from "../SendEmailForm";

const GlobalNavigationBar = () => {

    const [isOpenEmailModal, setIsOpenEmailModal] = useState(false);
    useEffect(() => {
        showHideBodyContainer(isOpenEmailModal);
    }, [isOpenEmailModal]);

    const targetList = [
        {
            title: '📧 이메일 문의',
            type: 'mail',
            path: '/',
        },
        {
            title: '🏠 개발 블로그',
            type: 'link',
            path: 'https://letsdodev.tistory.com/',
        },
        {
            title: '🛅 깃허브',
            type: 'link',
            path: 'https://github.com/ljbok/',
        },
    ]

    const getNavbarPath = (item) => {
        if (!item) return '#';
        if (item.type === 'mail') {
          return '#'
        }
        return item.path || '#';
    }


    return (
        <>
            <div className="nav-scroller border-bottom">
                <nav className="nav nav-underline justify-content-between">
                    <a className=" empty-gnb-item nav-item nav-link link-body-emphasis active" href="#"></a>
                    {targetList.map((item, index) =>
                        <a className=" empty-gnb-item nav-item nav-link link-body-emphasis "
                            href={getNavbarPath(item)}
                            target="_blank"
                            onClick={(e) => {
                                if(item.type === 'mail') {
                                    e.preventDefault();
                                    setIsOpenEmailModal(true);
                                }
                            }}
                           rel="noreferrer"
                           key={`nav-${index+1}`}>
                            {item.title}
                        </a>
                    )}
                    <a className="empty-gnb-item nav-item nav-link link-body-emphasis " href="#"></a>
                </nav>
            </div>
            {isOpenEmailModal && (
                <SendEmailForm setIsOpenEmailModal={setIsOpenEmailModal}/>
            )}
        </>
    )
}

export default GlobalNavigationBar;